import styled from '../../../lib/styled';
import React from 'react';
import { FC } from 'react';
import { colors } from '../../Shared/Style/colors';
import Icon from '../warning-sign.svg';

const ThemedWarningSign = styled(Icon)(() => {
    return {
        height: '24px',
        width: '24px',
        '& g': {
            stroke: colors.black,
        },
        '& path': {
            stroke: colors.black,
        },
        '& polyline': {
            stroke: colors.black,
        },
        '& line': {
            stroke: colors.black,
        },
    };
});
const WarningSign: FC = ({ ...rest }) => {
    return <ThemedWarningSign viewBox="0 0 48 48" {...rest} />;
};

export default WarningSign;
